import { useQuery, useQueryClient } from "@tanstack/react-query";
import { InvoiceService } from "../../application/services/invoiceService";
import React from "react";

const invoiceService = new InvoiceService();

export const invoiceKeys = {
  all: ["invoices"],
  byIndex: (index) => [...invoiceKeys.all, "byIndex", index],
};

export const useInvoicesByIndex = (index = 0, options = {}) => {
  const queryClient = useQueryClient();

  const result = useQuery({
    queryKey: invoiceKeys.byIndex(index),
    queryFn: async () => {
      const response = await invoiceService.getInvoicesBySmartIndex(index);
      if (!response.success) {
        throw new Error(response.message);
      }
      return response.data;
    },
    staleTime: options.staleTime ?? 50 * 60 * 1000,
    gcTime: options.gcTime ?? 60 * 60 * 1000,
    refetchOnMount: options.refetchOnMount ?? false,
    refetchOnWindowFocus: options.refetchOnWindowFocus ?? false,
    refetchOnReconnect: options.refetchOnReconnect ?? false,
    retry: options.retry ?? 1,
    enabled: options.enabled ?? true,
    ...options,
  });

  React.useEffect(() => {
    if (result.data?.hasNext) {
      queryClient.prefetchQuery({
        queryKey: invoiceKeys.byIndex(index + 1),
        queryFn: () => {
          return invoiceService.getInvoicesBySmartIndex(index + 1).then(res => {
            if (res.success) return res.data;
            throw new Error(res.message);
          });
        },
      });
    }
  }, [result.data, index, queryClient]);

  return result;
};